import { dedupe } from '../../utils/listUtils'
import { GobArApi } from './gobAr'
import { Localidad, Provincia } from './types'

export const useGobArActions = () => {
    const gobArApi = GobArApi()

    const getProvinces = async (): Promise<Provincia[]> => {
        return gobArApi.getProvinces().then(response => response.provincias)
    }

    const getLocalities = async (): Promise<Localidad[]> => {
        return gobArApi.getLocalities().then(response => {
            const { localidades } = response
            const nombres = dedupe(localidades.map((localidad: Localidad) => localidad.nombre))
            return nombres.map(nombre => localidades.find((localidad: Localidad) => localidad.nombre === nombre))
        })
    }

    return {
        getProvinces,
        getLocalities
    }
}
